import { createEl } from 'createElement';

let transitions = {
  'fadeOut': ( props ) => {
    let container = props.el
    if(! props.el) {
      container = createEl('div', {}, document.getElementById('root') )
    }
    setTimeout( () => {
      container.setAttribute('data-transition', 'fadeOut')
      container.classList.add('transiion')
      container.classList.add('fadeOut')
    }, 10 )

    let timeout = 500
    setTimeout( () => {
      container.parentNode.removeChild(container)
    }, timeout )
    setTimeout( () => {
      if(props.onEnd) {
        props.onEnd()
      }
    }, timeout + 50) // safety
  },
  'fadeFromWhite': ( props ) => {
    let container = createEl('div', {class: 'transition', "data-transition": "fadeFromWhite"}, document.getElementById('root') )
    setTimeout( () => {
      container.classList.add('fadeOut')
    }, 10 )
    setTimeout( () => {
      container.parentNode.removeChild(container)
    }, 4000 )
    props.onEnd()
  }
}

function transition(name, props = {} ) {
  let existingTransition = document.querySelector('.transition')
  if(existingTransition) {
    existingTransition.parentNode.removeChild(existingTransition)
  }
  const thisTransition = transitions[name]
  if(! thisTransition.name) {
    return console.error(`No transition found by the name of ${name}.`)
  }
  // console.log(name, thisTransition)
  let el = props.el || null
  thisTransition( {el: el, onEnd: props.onEnd} )
}

export {transition}
